(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bam-chat"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-bam-chat]').forEach(function (root) {
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-bam-chat-data]').textContent); } catch (e) { data = {}; }
    var intents = data.intents || [];
    var fallback = data.fallback || "Ask me about our BAM! boards, sizes, prices, shipping or how to play!";

    var win = root.querySelector('[data-win]');
    var openBtn = root.querySelector('[data-open]');
    var closeBtn = root.querySelector('[data-close]');
    var form = root.querySelector('[data-form]');
    var input = root.querySelector('[data-input]');
    var msgs = root.querySelector('[data-msgs]');
    var typing = root.querySelector('[data-typing]');
    var chipsBar = root.querySelector('[data-chips]');
    var busy = false;

    function openChat() { win.hidden = false; win.classList.add('is-open'); openBtn.style.display = 'none'; setTimeout(function () { input.focus(); }, 120); }
    function closeChat() { win.classList.remove('is-open'); win.hidden = true; openBtn.style.display = ''; }
    openBtn.addEventListener('click', openChat);
    closeBtn.addEventListener('click', closeChat);

    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    // Resalta palabras en MAYÚSCULAS con el estilo cómic
    function fmt(s) { return s.replace(/\b([A-ZÁÉÍÓÚÑ!¡¿?]{3,})\b/g, '<span class="bam-chat__hl">$1</span>'); }
    function scrollDown() { msgs.scrollTop = msgs.scrollHeight; }

    function addMsg(text, isUser) {
      var row = document.createElement('div');
      row.className = 'bam-chat__row bam-chat__row--in ' + (isUser ? 'is-user' : 'is-bot');
      var bubble = document.createElement('div');
      bubble.className = 'bam-chat__bubble ' + (isUser ? 'bam-chat__bubble--user' : 'bam-chat__bubble--bot');
      bubble.innerHTML = isUser ? esc(text) : fmt(esc(text));
      row.appendChild(bubble);
      msgs.appendChild(row);
      scrollDown();
    }

    // Normaliza: minúsculas, sin acentos, sin signos
    function norm(s) {
      return (' ' + String(s).toLowerCase() + ' ').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ');
    }

    // Puntúa cada tema y devuelve el que mejor encaja en la frase entera.
    // Frase completa = 3 puntos; palabra suelta = 1 punto. Gana la mayor puntuación.
    function findAnswer(text) {
      var t = norm(text);
      var words = {};
      t.trim().split(' ').forEach(function (w) { if (w) words[w] = true; });
      var best = null, bestScore = 0;
      for (var i = 0; i < intents.length; i++) {
        var keys = intents[i].k || [];
        var score = 0;
        for (var j = 0; j < keys.length; j++) {
          var kw = norm(keys[j]).trim();
          if (!kw) continue;
          if (kw.indexOf(' ') >= 0) { if (t.indexOf(' ' + kw + ' ') >= 0) score += 3; }
          else { if (words[kw]) score += 1; }
        }
        if (score > bestScore) { bestScore = score; best = intents[i]; }
      }
      return (best && bestScore > 0) ? best.a : fallback;
    }

    function botReply(text) {
      busy = true;
      typing.hidden = false;
      scrollDown();
      setTimeout(function () {
        typing.hidden = true;
        addMsg(findAnswer(text), false);
        busy = false;
      }, 500);
    }
    function handleUser(text) {
      text = (text || '').trim();
      if (!text || busy) return;
      addMsg(text, true);
      botReply(text);
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); var t = input.value; input.value = ''; handleUser(t); });

    // Botones de respuesta rápida
    (data.quickReplies || []).forEach(function (label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bam-chat__chip';
      b.textContent = label;
      b.addEventListener('click', function () { handleUser(label); });
      chipsBar.appendChild(b);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
